import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

interface Props {
  title: string;
  pitch: string;
  features: ReadonlyArray<string>;
}

export function Stub({ title, pitch, features }: Props) {
  return (
    <div className="flex flex-col gap-10 max-w-4xl animate-fade-up">
      <Link
        to="/"
        className="font-mono text-[10px] uppercase tracking-folio text-[var(--fg-muted)] hover:text-[var(--fg)] inline-flex items-center gap-1.5"
      >
        <ArrowLeft size={12} /> Back to home
      </Link>

      <header className="rule-double pt-6">
        <h1
          className="font-display font-extrabold tracking-tight mt-3 leading-[0.95]"
          style={{ fontSize: "clamp(46px, 6vw, 72px)" }}
        >
          {title}
        </h1>
        <p className="font-display text-[20px] text-[var(--fg-muted)] mt-3 italic max-w-prose">
          {pitch}
        </p>
      </header>

      <section>
        <div className="np-label mb-2">Planned</div>
        <ul className="divide-y" style={{ borderColor: "var(--rule)" }}>
          {features.map((f) => (
            <li key={f} className="py-3 font-sans text-[14px] leading-snug">
              {f}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
